<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.purchase_entry">
    <div class="banner center" style="max-width:1200px;">
        <div class="row row_header freeze_height" style="border: none;">
            <div class="col-4">
                <ngx-select [items]="purchaseEntryTypes" [optionValueField]="'key'" [optionTextField]="'value'"
                    placeholder="{{localService.languageContent.purchase_entry.entry_type}}"
                    [(ngModel)]="selectedPurchaseEntryType" [noAutoComplete]="true" (select)="onLoad()">
                </ngx-select>
            </div>
            <div class="col-8" style="text-align: right;">
                <label style="font-weight: normal; margin-left: 30px;">
                    <input type="checkbox" [(ngModel)]="isShowInActive" (change)="onLoad()" />
                    <span class="normal_color">{{localService.languageContent.purchase_entry.show_inactive}}</span>
                </label>
            </div>
        </div>
        <div class="row row_header freeze_height">
            <div class="col-1">
                {{localService.languageContent.table.action}}
            </div>
            <div class="col-4">
                {{localService.languageContent.table.title}}
            </div>
            <div class="col-4">
                {{localService.languageContent.purchase_entry.supplier_name}}
            </div>
            <div class="col-2">
                {{localService.languageContent.table.created_on}}
                <div class="icon_action_header">
                    <button class="button_icon button_icon_color" (click)="onAction(1)">
                        note_add
                    </button>
                </div>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div *ngIf="(source && source.items.length > 0)" class="item-found">
                <div class="row styled_row" *ngFor="let item of source.items">
                    <div class="col-md-1">
                        <a class="button"
                            [routerLink]="['/purchase-entry-details' + localService.basicParamsString,businessId,item.key]">
                            <i class="material-icons button icon_adjust">account_tree</i>
                        </a>
                        <button class="button_icon button_icon_color icon_adjust" (click)="onAction(1,item.key)">
                            edit
                        </button>
                    </div>
                    <div class="col-md-4">
                        <button class="button_icon icon_adjust"
                            title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                            (click)="onActiveInactiveStatus(item.key)"
                            [ngStyle]="{'color': item.v4 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v4 == '1' ?
                            "toggle_on" : "toggle_off"}}</button>
                        <span class="en">
                            {{item.v3 ?? item.v7}}
                        </span>
                    </div>
                    <div class="col-md-4">
                        <span [ngClass]="localService.getLanguageCode(item.v10)">
                            {{item.v9 ?? '-'}}
                        </span>
                    </div>
                    <div class="col-md-3">
                        <span class="en">
                            {{item.v8 | localDate}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="source && source.paging" [paging]="source.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<div>
    <app-purchase-entry [(isOpenPopup)]="isOpenPurchaseEntry" [purchaseEntryTypes]="purchaseEntryTypes"
        [businessId]="businessId" [id]="selectedPurchaseEntryId" (onClose)="onLoad()" />
</div>